import { PropsWithChildren } from "react";
import Header from "@components/layout/Header";
import Menu, { MenuItem, PageType } from "@components/layout/Menu";
import Footer from "@components/layout/Footer";
import { MainMenuData } from "@config/nav";
import FeedbackFooter from "@components/FeedbackFooter";
import { HtmlPageTitle } from "@components/HtmlPageTitle";
import { Main } from "@components/layout/Main";

export type DocChromeProps = PropsWithChildren & {
  title?: string;
  selectedPage?: string;
  leftMenu?: MenuItem[];
  leftMenuType?: PageType;
};

const defaultProps = {
  title: "",
  selectedPage: "",
  leftMenu: [MainMenuData],
  leftMenuType: "main" as PageType,
};

export const handleTitleCapitalizationExceptions = (title: string) =>
  title
    .replace("Api", "API")
    .replace("Lora", "LoRa")
    .replace("Sdks", "SDKs")
    .replace("Mcus", "MCUs");

export const DocChrome = ({
  children,
  selectedPage = defaultProps.selectedPage,
  title = defaultProps.title,
  leftMenu = defaultProps.leftMenu,
  leftMenuType = defaultProps.leftMenuType,
}: DocChromeProps) => (
  <>
    {title && (
      <HtmlPageTitle title={handleTitleCapitalizationExceptions(title)} />
    )}
    <Header selectedPage={selectedPage} />
    <Menu menus={leftMenu} type={leftMenuType} />
    <Main>
      {children}
      <FeedbackFooter />
    </Main>
    <Footer />
  </>
);

DocChrome.defaultProps = defaultProps;

const forceNamedExports = {};
export default forceNamedExports;
